import { isInpatientBilling } from 'constants/treatment';

export function isInpatientBooking(item) {
  if (!item) return false;
  if (
    isInpatientBilling(
      item.careType ?? item.care_type,
      item.billingMode ?? item.billing_mode
    )
  ) {
    return true;
  }
  const serviceName = String(
    item.serviceName ?? item.service_name ?? item.service?.name ?? ''
  ).toLowerCase();
  return serviceName.includes('стационар');
}

export function compareBookingsByTime(a, b) {
  const timeCmp = String(a?.time || '').localeCompare(String(b?.time || ''));
  if (timeCmp !== 0) return timeCmp;
  return String(a?.clientName || a?.client_name || '').localeCompare(
    String(b?.clientName || b?.client_name || ''),
    'ru'
  );
}

/** Сначала амбулаторные, затем стационар; внутри группы — по времени. */
export function sortBookingsByCareTypeAndTime(items) {
  return [...items].sort((a, b) => {
    const groupA = isInpatientBooking(a) ? 1 : 0;
    const groupB = isInpatientBooking(b) ? 1 : 0;
    if (groupA !== groupB) return groupA - groupB;
    return compareBookingsByTime(a, b);
  });
}

export function groupBookingsByCareType(items) {
  const outpatient = [];
  const inpatient = [];
  (items || []).forEach((item) => {
    if (isInpatientBooking(item)) inpatient.push(item);
    else outpatient.push(item);
  });
  return {
    outpatient: outpatient.sort(compareBookingsByTime),
    inpatient: inpatient.sort(compareBookingsByTime),
  };
}
